import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { TranslationService } from '../../../modules/i18n/translation.service';
import { InitialsPipe } from '../../../pipes/initials.pipe';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { ThemeModeSwitcherComponent } from '../../theme-mode-switcher/theme-mode-switcher.component';
import { AuthService } from '../../../services/auth.service';
@Component({
	selector: 'app-user-inner',
	templateUrl: './user-inner.component.html',
	imports: [CommonModule, InitialsPipe, TranslatePipe, ThemeModeSwitcherComponent, TranslateModule],
	standalone: true,
})
export class UserInnerComponent implements OnInit, OnDestroy {
	@HostBinding('class')
	class = `menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px`;
	btnClass = 'h-auto btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary ms-3';
	@HostBinding('attr.data-kt-menu') dataKtMenu = 'true';

	@Input() user: any;

	language!: LanguageFlag;
	user$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	langs = languages;
	isPayAdmin = false;

	private unsubscribe: Subscription[] = [];
	private translationService = inject(TranslationService);
	private auth = inject(AuthService);

	ngOnInit(): void {
		this.user$.next(this.user);
		this.setLanguage(this.translationService.getSelectedLanguage());
	}

	logout() {
		this.auth.logout();
	}

	selectLanguage(lang: string) {
		this.translationService.setLanguage(lang);
		this.setLanguage(lang);
	}

	setLanguage(lang: string) {
		this.langs.forEach((language: LanguageFlag) => {
			if (language.lang === lang) {
				language.active = true;
				this.language = language;
			} else {
				language.active = false;
			}
		});
	}

	onLinkClick(event: MouseEvent): void {
		event.stopPropagation();
	}

	ngOnDestroy() {
		this.unsubscribe.forEach((sb) => sb.unsubscribe());
	}
}

interface LanguageFlag {
	lang: string;
	name: string;
	flag: string;
	active?: boolean;
}

const languages = [
	{
		lang: 'en',
		name: 'en_EN',
		flag: './assets/media/flags/united-kingdom.svg',
	},
	{
		lang: 'fr',
		name: 'fr_FR',
		flag: './assets/media/flags/france.svg',
	},
	{
		lang: 'es',
		name: 'es_ES',
		flag: './assets/media/flags/spain.svg',
	},
	{
		lang: 'pt',
		name: 'pt_PT',
		flag: './assets/media/flags/portugal.svg',
	},
];
